import { Card, Flex, Text, Spacer } from '@chakra-ui/react';
import LineChart from '@/components/charts/line';
import DownloadButton from '@/components/ui/download-button';
import { Action } from '@/lib/types';

interface Props {
  title: string;
  count: number;
  actions: Action[];
  workspaceId: string;
  actionType: string;
  startDate: string;
  endDate: string;
}

const ActionCard = ({
  title,
  count,
  actions,
  workspaceId,
  actionType,
  startDate,
  endDate,
}: Props) => {
  return (
    <Card.Root borderWidth={'1px'} borderRadius={'lg'} borderColor={'border'}>
      <Card.Header pb={0} pt={3} px={5}>
        <Flex gap='4' alignItems='center' flexWrap='wrap'>
          <Text
            fontSize={'sm'}
            fontWeight={'medium'}
            textTransform={'capitalize'}
            color={'fg.muted'}
          >
            {title}
          </Text>
          <Spacer />
          <DownloadButton
            workspaceId={workspaceId}
            actionType={actionType}
            startDate={startDate}
            endDate={endDate}
          />
        </Flex>
        <Text fontSize={'2xl'} fontWeight={'bold'}>
          {count}
        </Text>
      </Card.Header>
      <Card.Body pt={3}>
        <LineChart label={title} actions={actions} height={180} />
      </Card.Body>
    </Card.Root>
  );
};

export default ActionCard;
